import { createSlice } from '@reduxjs/toolkit';

import { TENANT_TYPE } from 'types/general.types';

import { ConfigState, SaveBaseUrlSuccessfulAction, SetTenantAction } from './types';

const initialState: ConfigState = {
  tenant: TENANT_TYPE.DUCKENERGY,
  loading: true,
  clientId: '',
  domain: '',
};

export const configSlice = createSlice({
  name: 'config',
  initialState,
  reducers: {
    saveBaseUrlSuccessful(state: ConfigState, action: SaveBaseUrlSuccessfulAction) {
      state.loading = false;
    },
    saveBaseUrlFailed(state: ConfigState) {
      state.loading = false;
    },
    setTenant(state: ConfigState, { payload }: SetTenantAction) {
      state.tenant = Object.values<string>(TENANT_TYPE).includes(payload)
        ? (payload as TENANT_TYPE)
        : TENANT_TYPE.DUCKENERGY;
    },
  },
});

export default configSlice.reducer;

export const { saveBaseUrlFailed, saveBaseUrlSuccessful, setTenant } = configSlice.actions;
